import { Typography } from "@material-ui/core";
import React from "react";
import FlexiForm, { Fields } from "../../FlexiComponents/FlexiForm";
import Grid from "@material-ui/core/Grid/Grid";

const StuckAtDocUpload = ({ onSubmit, formId }) => {
  const secondSectionRadios = [
    {
      fieldType: "radio",
      name: `quest2`,
      label: "1",
      value: "1"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "2",
      value: "2"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "3",
      value: "3"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "4",
      value: "4"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "5",
      value: "5"
    }
  ];
  const fifthSectionRadios = [
    [
      {
        fieldType: "radio",
        name: `quest5`,
        label: "1",
        value: "1"
      },
      {
        fieldType: "radio",
        name: `quest5`,
        label: "2",
        value: "2"
      },
      {
        fieldType: "radio",
        name: `quest5`,
        label: "3",
        value: "3"
      },
      {
        fieldType: "radio",
        name: `quest5`,
        label: "4",
        value: "4"
      },
      {
        fieldType: "radio",
        name: `quest5`,
        label: "5",
        value: "5"
      }
    ]
  ];
  return (
    <>
      <FlexiForm
        id={formId}
        FinalFormFormProps={{
          onSubmit
        }}
        render={({ values }) => (
          <div>
            <Typography variant={"h5"}>
              Mi volt az oka annak, hogy nem tudtad befejezni a dokumentum
              feltöltést?
            </Typography>
            <Grid item xs={6}>
              <Fields
                config={[
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Nem volt nálam a szükséges dokumentum",
                      value: "a"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label:
                        "Nem volt egyértelmű, milyen dokumentumokra van szükség",
                      value: "b"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label:
                        "Technikai problémába ütköztem (nem tudtam feltölteni)",
                      value: "c"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Nem volt időm befejezni a folyamatot",
                      value: "d"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Más ok",
                      value: "e"
                    }
                  ]
                ]}
              />
              {values?.quest3 === "e" && (
                <Fields
                  config={[
                    [
                      {
                        fieldType: "text",
                        name: `freeText1`,
                        placeholder: "Kérjük, írj róla pár szót",
                        disabled: values?.quest1 !== "e"
                      }
                    ]
                  ]}
                />
              )}
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Mennyire volt egyértelmű, hogy milyen dokumentumokat kell
              feltölteni? (1 - egyáltalán nem, 5 - érthető volt)
            </Typography>
            <Grid item xs={6}>
              <Fields config={[secondSectionRadios]} />
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Tapasztaltál technikai problémát a feltöltés során?
            </Typography>
            <Grid item xs={6}>
              <Fields
                config={[
                  [
                    {
                      fieldType: "radio",
                      name: `quest3`,
                      label: "nem",
                      value: "a"
                    },
                    {
                      fieldType: "radio",
                      name: `quest3`,
                      label: "igen",
                      value: "b"
                    }
                  ]
                ]}
              />
              {values?.quest3 === "b" && (
                <Fields
                  config={[
                    [
                      {
                        fieldType: "text",
                        name: `freeText2`,
                        placeholder: "Kérjük, írj róla pár szót",
                        disabled: values?.quest3 !== "b"
                      }
                    ]
                  ]}
                />
              )}
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Mi segítene a dokumentum feltöltés befejezésében?
            </Typography>
            <Grid item xs={6}>
              <Fields
                config={[
                  [
                    {
                      fieldType: "radio",
                      name: `quest4`,
                      label: "Részletesebb útmutató a feltöltéshez",
                      value: "a"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest4`,
                      label: "Ügyfélszolgálati segítség",
                      value: "b"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest4`,
                      label: "Több idő a feltöltésre",
                      value: "c"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest4`,
                      label: "Kevesebb dokumentációs igény",
                      value: "d"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest4`,
                      label: "Más megoldás",
                      value: "e"
                    }
                  ]
                ]}
              />
              {values?.quest4 === "e" && (
                <Fields
                  config={[
                    [
                      {
                        fieldType: "text",
                        name: `freeText3`,
                        placeholder: "Kérjük, írj róla pár szót",
                        disabled: values?.quest4 !== "e"
                      }
                    ]
                  ]}
                />
              )}
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Mennyire valószínű, hogy a közeljövőben folytatod a folyamatot és
              befejezed a feltöltést? (1 - egyáltalán nem, 5 - valószínű)
            </Typography>
            <Grid item xs={6}>
              <Fields config={fifthSectionRadios} />
            </Grid>
          </div>
        )}
      />
    </>
  );
};

export default StuckAtDocUpload;
